<template>
    <div>
        <PageHeader>
            {{ $t('aggregateModeration') }}
        </PageHeader>
        <Filters ref="Filters" />
        <Results ref="Results" />
    </div>
</template>



<script>
    import { CATALOG_STATUS } from '@/services/productService';
    import viewFiltersMixin from '@/mixins/viewFiltersMixin';
    import Filters from './parts/Filters.vue';
    import Results from './parts/Results.vue';

    const DEFAULT_FILTERS_PARAMS = Object.freeze({
        id: null,
        catalogId: null,
        statuses: [],
        riskScoreFrom: null,
        riskScoreTo: null,
        riskScoresFrom: {},
        riskScoresTo: {},
    });
    const DEFAULT_TABLE_PARAMS = Object.freeze({
        perPage: 25,
        page: 1,
        sort: 'id',
        order: 'DESC',
    });

    export default {
        name: 'AggregateModeration',
        mixins: [viewFiltersMixin],
        components: {
            Filters,
            Results,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                ...this.initParams(DEFAULT_FILTERS_PARAMS, DEFAULT_TABLE_PARAMS),
                request: this.$req('product/products'),
                requestRiskDimensions: this.$req('product/RiskDimensions'),
            };
        },
        computed: {
            requestParams() {
                return {
                    ...this.requestParamsFilters,
                    ...this.requestParamsTable,
                    catalogStatuses: [CATALOG_STATUS.FOR_MODERATION], // pozwala pobrać tylko agregaty, które zostały zakwalifikowane do moderacji
                };
            },
            riskDimensions() {
                return this.requestRiskDimensions.getData() || [];
            },
            risks() {
                return this.riskDimensions.reduce((acc, item) => ({ ...acc, [item.value]: item.label }), {});
            },
        },
        watch: {
            riskDimensions: {
                handler: 'initRiskFilters',
            },
        },
        methods: {
            fetchRiskDimensions() {
                return this.requestRiskDimensions.get();
            },
            initRiskFilters(risks) {
                risks.forEach(item => {
                    this.$set(this.defaultFiltersParams.riskScoresFrom, item.value, null);
                    this.$set(this.defaultFiltersParams.riskScoresTo, item.value, null);
                });
                this.initDataFromQuery();
                const data = risks.reduce((acc, item) => ({ ...acc, [item.value]: null }), {});
                this.$set(this.filters, 'riskScoresFrom', { ...structuredClone(data), ...this.filters.riskScoresFrom });
                this.$set(this.filters, 'riskScoresTo', { ...structuredClone(data), ...this.filters.riskScoresTo });
            },
        },
        created() {
            this.fetchRiskDimensions();
        },
    };
</script>
